<template>
  <div class="">
    <div class="row">
      <div class="col-md-12 col-sm-8">
        <div class="card card-default widget animated">
          <div class="card-heading">
            <form v-on:submit="createMobileDevice">
              <div class="col-md-5">
                <h5>Information</h5>
                <br>
                <form-text styler="font-size:35px" ref="name" label="Name" name="name" v-model="mobileDevice.name" validation="required"></form-text>
                <form-text label="MDM Device ID" name="mdm_device_id" v-model="mobileDevice.mdm_device_id"></form-text>
                <div class="form-group">
                  <v-select placeholder="Assigned Users" multiple :options="users" label="name" name="users" :value.sync="mobileDevice.props.users"></v-select>
                </div>
              </div>              
              <div class="col-md-5">
                <br>
                <div class="form-group">
                    <button type="submit" class="btn btn-success btn-lg">Create</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div><!-- /.col-md-9 -->
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import VueMask from 'v-mask'
import FormText from '../../../elements/Form/FormText'
import database from '../../../webmaster/Database/database'
import vSelect from 'vue-select'

Vue.use(VueMask);
Vue.use(VeeValidate);

export default {
  name: 'mobiledevice',
  components:{
    'form-text':FormText,
    vSelect
  },
  data () {
    return {
        mobileDevice: {
          name: '',
          mdm_device_id: '',
          type: 'Mobile Device',
          props:{
            users: []
          }
        },
        users:[],
    }
  },
  created:function(){
    //Populate users
    var ref = '/orgs/' + this.$store.state.usermain.curOrg.id + '/users'
    this.$bindAsArray('users', database.getRef(ref));
  },
  methods: {
    createMobileDevice:function(e){
      e.preventDefault()
      let promises = [];
      var self = this;
      for (let child in this.$refs) promises.push(this.$refs[child].$validator.validateAll());
      Promise.all(promises).then(this.$validator.validateAll()).then(() => { 
        var deviceUsers = {}
        for (var user in self.mobileDevice.props.users) {
            var obj = self.mobileDevice.props.users[user];
            deviceUsers[obj['.key']] ={
              empty: "empty"
            }
        }
        var device = {
          name: self.mobileDevice.name,
          mdm_device_id: self.mobileDevice.mdm_device_id,
          type: self.mobileDevice.type,
          props:{
            users: deviceUsers
          }
        }
        var curOrgId = self.$store.state.usermain.curOrg.id
        var newDeviceKey = database.getDb().ref().child('orgs').child(curOrgId).child('devices').push().key;
        var updates = {};
        updates['/orgs/' + curOrgId + '/devices/' + newDeviceKey] = device;
        database.getDb().ref().update(updates, function(){
          self.$router.push('/admin/devices')
        });
      }, () => {});
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// CreateMobileDevice.vue?2b98b608